import invariant from 'tiny-invariant';
import { toKebabCase } from './strings.js';

/**
 * Convert a string to error key
 * @param {string} key
 * @returns {string}
 */

function toErrorKey(key) {
  if (!key) {
    return "errors.general.unknown";
  }

  return "errors.".concat(toKebabCase(key));
}
/**
 * Convert array of strings to translation key
 * @param {Array.<string>} keysArray
 * @returns {string}
 */

function toTranslationKey(keysArray) {
  invariant(keysArray != null, '"keysArray" was not provided.');
  return keysArray.map(key => toKebabCase(key)).join(".");
}

export { toErrorKey, toTranslationKey };
